import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { jwtDecode } from 'jwt-decode';
import PKCE from 'js-pkce';

const COGNITO_DOMAIN = 'https://us-east-1exgw1w6ev.auth.us-east-1.amazoncognito.com';
const responseType = 'code'; 
export const COGNITO_CB_ENDPOINT = 'callback';

export class CognitoAuthMgr {
  constructor({ pool }) {
    this.pool = pool;
    this.user_pool = new AmazonCognitoIdentity.CognitoUserPool(pool);
    this.current_login = null;
    this.state = 'LOGGED OUT';
    this.__pkce = null;
  }

  get state() {
    return this.current_login?.state || 'LOGGED OUT';
  }

  set state(newState) {
    console.log('Updating state in CognitoAuthMgr:', newState);
    if (this.current_login) {
      this.current_login.state = newState;
    } else {
      this.current_login = { state: newState };
    }
  }

  doLogin({ id_token, access_token, refresh_token }) {
    try {
      if (!id_token) {
        throw new Error('ID token is required for login.');
      }

      const id = jwtDecode(id_token);
      console.log('Decoded ID token:', id);

      this.current_login = {
        id_token,
        access_token,
        refresh_token,
        email: id.email,
        roles: id['cognito:groups'] || [],
        expiration: id.exp,
        name: id.given_name || id.name || id.email.split('@')[0],
      };

      this.state = 'LOGGED IN';
      console.log('State updated to LOGGED IN');
    } catch (error) {
      console.error('Error decoding token:', error);
      this.state = 'LOGGED OUT';
    }
  }

  async refresh() {
    console.log('Refreshing tokens...');
    const refreshToken = this.current_login?.refresh_token;

    if (!refreshToken) {
      throw new Error('No refresh token available.');
    }

    const tokenEndpoint = `${COGNITO_DOMAIN}/oauth2/token`;
    const body = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: this.pool.ClientId,
      refresh_token: refreshToken,
    });

    const response = await fetch(tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    });

    if (!response.ok) {
      throw new Error(`Token refresh failed: ${response.statusText}`);
    }

    const tokens = await response.json();
    console.log('New tokens received:', tokens);
    this.doLogin(tokens); // Update the current login state
    return tokens.id_token;
  }

  async attemptAFSCMESSO() {
    console.log('Starting SSO...');
    const authorizeUrl = this.pkce.authorizeUrl();
    window.location.replace(authorizeUrl);
  }

  async completeSSO(location) {
    try {
      if (location.pathname === `/${COGNITO_CB_ENDPOINT}`) {
        const tokens = await this.pkce.exchangeForAccessToken(location.href);
        this.doLogin(tokens);
        this.state = 'LOGGED IN';
        history.replaceState({}, "", "/");
        console.log('SSO complete, state updated to LOGGED IN');
      } else {
        console.log('No SSO callback detected.');
      }
    } catch (error) {
      console.error('Error completing SSO:', error);
      this.state = 'LOGGED OUT';
    }
  }

  get pkce() {
    if (!this.__pkce) {
      this.__pkce = new PKCE({
        client_id: this.pool.ClientId,
        redirect_uri: `${window.location.origin}/${COGNITO_CB_ENDPOINT}`,
        authorization_endpoint: `${COGNITO_DOMAIN}/oauth2/authorize`,
        token_endpoint: `${COGNITO_DOMAIN}/oauth2/token`,
        requested_scopes: 'email openid profile',
      });
    }
    return this.__pkce;
  }
}